import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import HasilPemeriksaanUsgSvc from "@/services/HasilPemeriksaanUsg";

@Module({ store, dynamic: true, namespaced: true, name: "hasil-pemeriksaan-usg" })
class HasilPemeriksaanUsgModule extends VuexModule {
  items: any[] = [];
  loading = false;

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val || [];
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await HasilPemeriksaanUsgSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(Array.isArray(data) ? data : []);
    } catch {
      this.SET_ITEMS([]);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
  }
}

export const storeHasilPemeriksaanUsg = getModule(HasilPemeriksaanUsgModule);
